<kendo-formfield>
    <kendo-label [text]="caption | translate">
    </kendo-label>
    <kendo-combobox #employeesList [ngClass]="{'fx-fill': settings.fxFill}" [data]="employeesList$ | async"
        [textField]="'nameAndSurname'" [valueField]="'id'" [valuePrimitive]="true" [formControl]="control"
        [filterable]="true" [kendoDropDownFilter]="filterSettings"  (valueChange)="onChange($event)">
        <ng-template kendoComboBoxItemTemplate let-employee>

            <div fxFill fxLayout="row" class="employee">
                <div fxLayout="column" class="employee-details">
                    <div class="employee-name">
                        <kendo-icon *ngIf="!employee.linkedEnabledUsersCount" name="cancel" themeColor="error" size="large"></kendo-icon>
                        {{ employee.name }} - {{ employee.surname }}
                    </div>
                    <div class="employee-position">{{ employee.position }}</div>
                </div>
            </div>
        </ng-template>
    </kendo-combobox>
</kendo-formfield>